import { NewsCardSkeleton } from '@/components/NewsCardSkeleton'

const gridCols = {
  2: 'grid-cols-2',
  3: 'grid-cols-2 lg:grid-cols-3',
  4: 'grid-cols-2 lg:grid-cols-3 xl:grid-cols-4',
} as const

/** NewsGrid ile aynı kolon kırılımları */
export default function NewsSkeleton({
  count = 8,
  columns = 4,
  plain = false,
  showDate = true,
}: {
  count?: number
  columns?: 2 | 3 | 4
  plain?: boolean
  showDate?: boolean
}) {
  return (
    <div className={`grid min-w-0 gap-3 sm:gap-5 lg:gap-6 ${gridCols[columns]}`}>
      {Array.from({ length: count }, (_, i) => (
        <NewsCardSkeleton key={i} plain={plain} showDate={showDate} />
      ))}
    </div>
  )
}
